import React from "react";

import { useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";

import ROUTES from "@app/common/routes";
import usePageTitle from "@app/utils/hooks/usePageTitle";

import Button from "@rui/Button";
import { Column, Row } from "@rui/Stack";

import ERROR_PAGE_DATA from "./errorPageData";

type ErrorPageTypes = "not_found" | "crash" | "server_crash";

const ErrorPage = ({ type }: { type: ErrorPageTypes }) => {
  const {
    backgroundColor,
    cardBackgroundColor,
    icon,
    buttonIcon,
    buttonText,
    title,
    subtitle,
    body,
    pageTitle,
  } = ERROR_PAGE_DATA[type];

  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const handleClick = () => {
    if (type === "not_found" || type === "server_crash") {
      navigate(ROUTES.LANDING_PAGE);
    }

    if (type === "crash") {
      navigate(0);
    }
  };

  return (
    <Column
      variant="center"
      sx={{
        height: "100vh",
        width: "100vw",
        background: backgroundColor,
      }}
    >
      <Row
        sx={{
          width: "694px",
          height: "284px",
          background: cardBackgroundColor,
          borderRadius: "16px",
          py: 5,
          px: 2,
        }}
      >
        <Column variant="center" sx={{ height: "100%", flex: 1 }}>
          <img src={icon} style={{ width: "180px" }} />
        </Column>
        <Column
          justifyContent="space-around"
          alignItems="flex-start"
          sx={{ height: "100%", flex: 1.75 }}
        >
          <Typography
            variant="h3"
            sx={{ color: "shades.neutral.800", fontWeight: 600 }}
          >
            {title}
          </Typography>
          <Column spacing={1} margin="auto">
            <Typography variant="bodyPrimaryReg" color="shades.neutral.500">
              {subtitle}
            </Typography>
            <Typography
              variant="bodyPrimaryReg"
              // App crashes don't grab theme colors consistently -- hardcoding this here
              color="#282828"
            >
              {body}
            </Typography>
          </Column>
          <Button onClick={handleClick} endIcon={buttonIcon}>
            {buttonText}
          </Button>
        </Column>
      </Row>
    </Column>
  );
};

export default ErrorPage;
